import { createType } from '../dependencies';

export default {
    ...createType('REQUEST_RESTAURANTS'),
    ...createType('CHECK_SELECTED_RESTAURANTS'),
    ...createType('RESTAURANTS_SETTINGS_LOAD'),
    ...createType('RESTAURANTS_SETTINGS_SAVE'),
    ...createType('TOGGLE_ALL_RESTAURANTS_SELECTED'),
    ...createType('TOGGLE_RESTAURANT', ['_SELECTED', '_FAVOURITE']),
    ...createType('SET', ['_RESTAURANTS', '_SELECTED', '_FAVOURITE']),
};
